import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { getColor } from '../../common/UICommon';
import { ButtonIcon } from '../../styledComponent/Buttons.style';

import { GroupDetailsProps } from './pickAGroupStep.types';
import { GroupsDetails } from '../../common/GroupsDetails';
import { MainFunnelButton } from '../../common/MainFunnelButton';

import closeIcon from '../../../assets/closeIcon.svg';

const RootBox = styled(Box)`
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
  background-color: ${getColor('WHITE')};
`;

const ContainerBox = styled(Box)`
  max-width: 444px;
  margin: 0 auto;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const Padding = styled.div`
  padding: 32px 32px 0 32px;
`;

export const GroupDetails = observer((props: GroupDetailsProps) => {
  const { isButtonDisabled, pickedGroupId, stepName, buttonSection, setIsOpen, pickedGroup } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onClick = () => {
    pickedGroup(pickedGroupId);
  };

  return (
    <RootBox>
      <ContainerBox>
        <Padding>
          <ButtonIcon onClick={() => setIsOpen(false)}>
            <img src={closeIcon} alt="close" />
          </ButtonIcon>
        </Padding>

        <GroupsDetails {...props} pickedGroupId={pickedGroupId} stepName={stepName} />
      </ContainerBox>

      <MainFunnelButton
        id="mainCta_PickAGroup"
        text={buttonSection.ctaButtonTitle}
        paymentInformation={buttonSection}
        onClick={onClick}
        disabled={isButtonDisabled}
      />
    </RootBox>
  );
});
